import isType from './is-type';
var isRegExp = function (str) {
    return isType(str, 'RegExp');
};
export default isRegExp;
//# sourceMappingURL=is-reg-exp.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/is-reg-exp.js
// module id = 500
// module chunks = 3